import { openExternalLink } from "@tvg/sh-utils/mobileUtils";

export const costumerSupportURL: string = "redirectEngine?type=messageUs";

export const getLiveChatURL = () => {
  if (!window) {
    return "";
  }

  return `${window.location.protocol}//${window.location.host}/${costumerSupportURL}`;
};

export const openLiveChat = () => {
  openExternalLink(getLiveChatURL());
};
